import { operatorApiFetch } from './apiService';

export const pickingMovementsService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('picking_movements/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  }
};

export default pickingMovementsService;
